import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    employeeBanks: [],
    employeeBanksCount: 0,
    employeeBank: {},
    employeeBankSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getEmployeeBanks(state) {
      return state.employeeBanks
    },
    getEmployeeBanksCount(state) {
      return state.employeeBanksCount
    },
    getEmployeeBank(state) {
      return state.employeeBank
    },
    getEmployeeBankSaveStatus(state) {
      return state.employeeBankSave
    },
  },
  mutations: {
    EMPLOYEE_BANKS_LIST(state, data) {
      state.employeeBanks = data
    },
    EMPLOYEE_BANK_VIEW(state, data) {
      state.employeeBank = data
    },
    EMPLOYEE_BANKS_COUNT(state, data) {
      state.employeeBanksCount = data
    },
    EMPLOYEE_BANK_SAVE(state, data) {
      state.employeeBankSave = data
    },
  },
  actions: {
    employeeBanksList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/hr/employee_bank', data)
        .then(response => {
          commit('EMPLOYEE_BANKS_LIST', response.data.data)
          commit('EMPLOYEE_BANKS_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    employeeBankView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'employee_bank.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/hr/employee_bank', data)
        .then(response => {
          commit('EMPLOYEE_BANK_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    employeeBankSave({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post('/hr/employee_bank/saveData', data)
        .then(response => {
          commit('EMPLOYEE_BANK_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
